export enum ObjectOperation {
    Create   = 'create',
    Update   = 'change',
    Delete   = 'delete',
    Counters = 'unread',
    Alarm    = 'alarm',
    Upload   = 'upload',
    Preview  = 'preview',
}
